(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-tk9-icu-native]";
  var PATCH_PRODUCT_ID = 4734560632931;
  var LIGHTWEIGHT_HARNESS_PRODUCT_ID = 8112753049699;
  var HARNESS_PRODUCT_IDS = [7090638356579, 6749766811747, 6886975340643, 8112753049699];
  var MAX_VISIBLE_OFFERS = 6;
  var HERO_GROUP_IDS = ["harness-setup", "seat-cover-setup", "home-setup", "pool-setup", "fan-setup"];
  var ACCESSORY_ROUTE_GROUP_IDS = [
    "backseat-accessory-route", "pool-accessory-route", "walk-accessory-route", "glove-cleanup-setup"
  ];
  var FALLBACK_GROUP_ID = "smart-best-sellers";

  /* ICU's ten archived paths remain the parity boundary. The additional
     native groups below are the previously built reverse-family routes; they
     use the same owned matching/suppression engine and the same visual shell. */
  var GROUP_OFFER_ORDER = {
    "harness-setup": [
      "custom-patch", "matched-leash", "matched-collar", "patch-variety",
      "waste-walk-kit-harness", "harness-cooling-fans", "harness-safety-belt", "molle-pouch", "harness-travel-bowl",
      "dog-goggles", "harness-hair-removal-gloves", "first-aid-kit"
    ],
    "seat-cover-setup": [
      "backseat-bed", "cargo-cover", "single-seat-cover", "dual-fans", "throw-blanket", "extra-safety-belt",
      "travel-bowl", "cover-doggles", "hair-removal-gloves"
    ],
    "fan-setup": [
      "fan-four-pack-upgrade", "fan-two-pack-upgrade", "fan-backseat-bed",
      "fan-safety-belt", "fan-doggles", "fan-travel-bowl", "fan-hair-removal-gloves"
    ],
    "pool-setup": [
      "pool-cover", "quick-dry-towel", "paw-drying-mat", "pool-travel-bowl",
      "pool-waste-bags", "pool-hair-removal-gloves"
    ],
    "home-setup": [
      "home-plush-bed-options", "home-furniture-cover-options", "home-hair-removal-gloves",
      "home-floor-mat", "home-waste-bags", "home-travel-bowl"
    ],
    "smart-best-sellers": [
      "default-travel-bowl", "default-waste-bags", "default-first-aid-kit",
      "default-cooling-fans", "default-seat-cover", "default-harness",
      "default-floor-mat", "default-pool"
    ],
    "walk-accessory-route": [
      "custom-patch", "matched-leash", "matched-collar", "patch-variety", "single-style-patch",
      "waste-walk-kit-accessory", "molle-pouch", "harness-safety-belt", "doggles-safety-belt",
      "harness-travel-bowl", "doggles-travel-bowl", "dog-goggles", "first-aid-kit",
      "doggles-hair-removal-gloves", "doggles-cooling-fans"
    ],
    "backseat-accessory-route": [
      "backseat-hero-cover", "backseat-cooling-fans", "backseat-safety-belt",
      "backseat-travel-bowl", "backseat-doggles", "backseat-hair-removal-gloves"
    ],
    "pool-accessory-route": [
      "pool-hero", "pool-cover-options", "pool-route-waste-bags",
      "pool-route-quick-dry-towel", "pool-route-paw-drying-mat",
      "pool-route-travel-bowl", "pool-route-hair-removal-gloves"
    ],
    "glove-cleanup-setup": [
      "gloves-seat-cover-options", "gloves-furniture-cover-options",
      "gloves-floor-mat-options"
    ]
  };

  function parseJsonScript(root, selector) {
    var node = root.querySelector(selector);
    if (!node) throw new Error("Missing native upsell configuration");
    return JSON.parse(node.textContent || "{}");
  }

  function sameOriginPath(value, expected) {
    var parsed = new URL(String(value || ""), window.location.origin);
    if (parsed.origin !== window.location.origin || parsed.pathname !== expected || parsed.search || parsed.hash) {
      throw new Error("Unsafe cart endpoint");
    }
    return parsed.pathname;
  }

  function safeAssetUrl(value) {
    var parsed = new URL(String(value || ""), window.location.origin);
    var allowedHost = parsed.origin === window.location.origin || parsed.hostname === "cdn.shopify.com";
    if (parsed.protocol !== "https:" || !allowedHost || !/\/assets\//.test(parsed.pathname)) {
      throw new Error("Unsafe asset endpoint");
    }
    return parsed.href;
  }

  function hardenConfig(config) {
    return {
      cartUrl: sameOriginPath(config.cartUrl, "/cart.js"),
      addUrl: sameOriginPath(config.addUrl, "/cart/add.js"),
      changeUrl: sameOriginPath(config.changeUrl, "/cart/change.js"),
      rulesUrl: safeAssetUrl(config.rulesUrl),
      pricesUrl: safeAssetUrl(config.pricesUrl),
      surface: "native_icu_cart_page",
      engineVersion: "2026-08-27-family-first-v16-deduped-upgrade"
    };
  }

  function fetchJson(url, options) {
    var controller = window.AbortController ? new AbortController() : null;
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 10000) : null;
    return fetch(url, Object.assign({
      credentials: "same-origin",
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      signal: controller ? controller.signal : undefined
    }, options || {})).then(function (response) {
      if (timeout) window.clearTimeout(timeout);
      return response.text().then(function (text) {
        var payload = {};
        try { payload = text ? JSON.parse(text) : {}; }
        catch (error) { payload = {}; }
        if (!response.ok) {
          var error = new Error("Cart request failed");
          error.status = response.status;
          throw error;
        }
        return payload;
      });
    }, function (error) {
      if (timeout) window.clearTimeout(timeout);
      throw error;
    });
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function money(cents) {
    return "$" + (Number(cents || 0) / 100).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + " USD";
  }

  function shortMoney(cents) {
    var amount = Math.abs(Number(cents || 0)) / 100;
    return "$" + amount.toLocaleString("en-US", {
      minimumFractionDigits: Math.abs(amount % 1) < 0.001 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function emit(state, name, detail) {
    var payload = Object.assign({
      event: name,
      tk9_surface: state.config.surface,
      tk9_engine_version: state.config.engineVersion,
      tk9_rules_version: state.rules && state.rules.version || ""
    }, detail || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (error) { /* analytics never blocks cart */ }
    try {
      window.dispatchEvent(new CustomEvent(name, { detail: payload }));
    } catch (error) { /* older browsers keep the cart path */ }
  }

  function cartHasProduct(cart, productId) {
    return (cart.items || []).some(function (line) {
      return Number(line.product_id) === Number(productId);
    });
  }

  function productInCartMap(cart) {
    var map = Object.create(null);
    (cart.items || []).forEach(function (line) { map[String(line.product_id)] = true; });
    return map;
  }

  function normalizeCartText(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function cartLineText(line) {
    var properties = line && line.properties && typeof line.properties === "object"
      ? Object.keys(line.properties).map(function (key) { return key + " " + line.properties[key]; }).join(" ")
      : "";
    var options = Array.isArray(line && line.options_with_values)
      ? line.options_with_values.map(function (item) { return item && item.value || ""; }).join(" ")
      : "";
    return [line && line.title, line && line.product_title, line && line.variant_title, options, properties].join(" ");
  }

  function cartContainsAnyText(cart, needles) {
    var haystack = normalizeCartText((cart.items || []).map(cartLineText).join(" "));
    return (needles || []).some(function (needle) {
      return haystack.indexOf(normalizeCartText(needle)) !== -1;
    });
  }

  function rawOfferSuppressed(raw, cart) {
    var products = productInCartMap(cart);
    if (Array.isArray(raw.requireProductInCart) && !raw.requireProductInCart.some(function (id) {
      return Boolean(products[String(id)]);
    })) return true;
    if (raw.suppressIfProductInCart === true && raw.productId && products[String(raw.productId)]) return true;
    if (Array.isArray(raw.suppressIfProductInCart) && raw.suppressIfProductInCart.some(function (id) {
      return Boolean(products[String(id)]);
    })) return true;
    if (Array.isArray(raw.suppressIfProductIdsPresent) && raw.suppressIfProductIdsPresent.some(function (id) {
      return Boolean(products[String(id)]);
    })) return true;
    if (raw.productId && raw.action !== "change_variant" && products[String(raw.productId)]) return true;
    return Boolean(raw.suppressIfCartContainsText && cartContainsAnyText(cart, raw.suppressIfCartContainsText));
  }

  function offerKey(offer) {
    return [offer.groupId || "", offer.id || "", offer.productId || ""].join(":");
  }

  function findRawGroup(rules, groupId) {
    return (rules.offerGroups || []).find(function (group) { return group.id === groupId; }) || null;
  }

  function rankForGroup(groupId, offerId) {
    var order = GROUP_OFFER_ORDER[groupId] || [];
    var index = order.indexOf(offerId);
    return index === -1 ? 1000 : index;
  }

  function allowOfferForPhase(groupId, offer, cart) {
    var order = GROUP_OFFER_ORDER[groupId] || [];
    if (order.indexOf(offer.id) === -1) return false;
    if (groupId !== "harness-setup") return true;
    var hasHarness = HARNESS_PRODUCT_IDS.some(function (id) { return cartHasProduct(cart, id); });
    var hasPatch = cartHasProduct(cart, PATCH_PRODUCT_ID);
    if (!hasHarness) return false;
    if (cartHasProduct(cart, LIGHTWEIGHT_HARNESS_PRODUCT_ID)) {
      return [
        "custom-patch", "matched-leash", "matched-collar", "patch-variety",
        "waste-walk-kit-harness", "harness-cooling-fans", "harness-safety-belt", "harness-travel-bowl",
        "dog-goggles", "harness-hair-removal-gloves", "first-aid-kit"
      ].indexOf(offer.id) !== -1 && (!hasPatch || offer.id !== "custom-patch");
    }
    return !hasPatch || offer.id !== "custom-patch";
  }

  function directOffer(raw, group, prices, cart) {
    // An unresolved swap may never degrade into a generic Add. The exact
    // source -> target variant plan is the safety contract for upgrades. Raw
    // refill candidates must also pass the same component and cart-content
    // suppression contract as core-resolved offers; otherwise bundle parts
    // can be incorrectly reintroduced merely to fill the six-card grid.
    if (!raw || raw.action === "change_variant" || !raw.productId || rawOfferSuppressed(raw, cart)) return null;
    var entries = Object.keys(prices.prices || {}).map(function (variantId) {
      return Object.assign({ variantId: Number(variantId) }, prices.prices[variantId]);
    }).filter(function (entry) {
      return Number(entry.productId) === Number(raw.productId) && entry.available !== false;
    });
    var fallback = Number(raw.fallbackVariantId || raw.variantId || 0);
    var chosen = entries.find(function (entry) { return entry.variantId === fallback; }) || entries[0];
    if (!chosen) return null;
    return Object.assign({}, raw, {
      action: "add",
      variantId: chosen.variantId,
      groupId: group.id,
      groupTitle: group.title,
      groupPriority: Number(group.priority || 0),
      color: "",
      size: "",
      contextChoices: []
    });
  }

  function offersForGroup(row, rules, prices, cart) {
    var group = row.group;
    var resolved = (row.offers || []).filter(function (offer) {
      return allowOfferForPhase(group.id, offer, cart);
    });
    var byIdentity = Object.create(null);
    resolved.forEach(function (offer) {
      byIdentity[String(offer.id) + ":" + String(offer.productId)] = offer;
    });

    var rawGroup = findRawGroup(rules, group.id);
    (rawGroup && rawGroup.offers || []).forEach(function (raw) {
      if (!allowOfferForPhase(group.id, raw, cart)) return;
      var identity = String(raw.id) + ":" + String(raw.productId);
      if (byIdentity[identity]) return;
      var resolvedDirect = directOffer(raw, group, prices, cart);
      if (resolvedDirect) {
        resolved.push(resolvedDirect);
        byIdentity[identity] = resolvedDirect;
      }
    });

    return resolved.sort(function (left, right) {
      return rankForGroup(group.id, left.id) - rankForGroup(group.id, right.id);
    });
  }

  function buildVisibleOffers(core, rules, prices, cart) {
    var recommendationSet = core.buildRecommendations(rules, cart, prices, { maxOffers: 20 });
    var coreRows = recommendationSet.byGroup || [];
    var cartProducts = productInCartMap(cart);

    function groupTriggered(group) {
      return (group.triggerProductIds || []).some(function (productId) {
        return Boolean(cartProducts[String(productId)]);
      });
    }

    function resolvedRow(groupId) {
      var group = findRawGroup(rules, groupId);
      if (!group) return null;
      var coreRow = coreRows.find(function (row) { return row.group.id === groupId; });
      var row = { group: group, offers: offersForGroup(coreRow || { group: group, offers: [] }, rules, prices, cart) };
      return row.offers.length ? row : null;
    }

    function activeRows(groupIds) {
      return groupIds.map(function (groupId) {
        var group = findRawGroup(rules, groupId);
        return group && groupTriggered(group) ? resolvedRow(groupId) : null;
      }).filter(Boolean).sort(function (left, right) {
        return Number(right.group.priority || 0) - Number(left.group.priority || 0);
      });
    }

    var visible = [];
    var seenProducts = Object.create(null);
    var seenVariants = Object.create(null);
    var usedRows = [];

    function addOffer(offer) {
      // Harness carts offer the current car belt in the paw-mat slot.
      if (offer && Number(offer.productId) === 6735967256675 && HARNESS_PRODUCT_IDS.some(function (id) { return cartHasProduct(cart, id); })) {
        var beltGroup = findRawGroup(rules, "harness-setup");
        var beltRaw = beltGroup && (beltGroup.offers || []).find(function (item) { return item.id === "harness-safety-belt" && Number(item.productId) === 8093010624611; });
        offer = beltRaw ? directOffer(Object.assign({}, beltRaw, { suppressIfCartContainsText: [] }), beltGroup, prices, cart) : null;
      }
      if (!offer || visible.length >= MAX_VISIBLE_OFFERS) return;
      var productKey = String(offer.productId || "");
      var variantKey = String(offer.variantId || "");
      if (productKey && seenProducts[productKey] || variantKey && seenVariants[variantKey]) return;
      if (productKey) seenProducts[productKey] = true;
      if (variantKey) seenVariants[variantKey] = true;
      visible.push(offer);
    }

    function fillRows(rows) {
      if (!rows.length || visible.length >= MAX_VISIBLE_OFFERS) return;
      rows.forEach(function (row) {
        if (usedRows.indexOf(row) === -1) usedRows.push(row);
      });
      var depth = 0;
      var hasMore = true;
      while (hasMore && visible.length < MAX_VISIBLE_OFFERS) {
        hasMore = false;
        rows.forEach(function (row) {
          if (visible.length >= MAX_VISIBLE_OFFERS) return;
          var offer = row.offers[depth];
          if (!offer) return;
          hasMore = true;
          addOffer(offer);
        });
        depth += 1;
      }
    }

    function fillSingleRow(row) {
      if (!row || visible.length >= MAX_VISIBLE_OFFERS) return;
      if (usedRows.indexOf(row) === -1) usedRows.push(row);
      row.offers.forEach(function (offer) {
        if (visible.length >= MAX_VISIBLE_OFFERS) return;
        addOffer(offer);
      });
    }

    var heroRows = activeRows(HERO_GROUP_IDS);
    var accessoryRows = activeRows(ACCESSORY_ROUTE_GROUP_IDS);
    var hasActiveHero = HERO_GROUP_IDS.some(function (groupId) {
      var group = findRawGroup(rules, groupId);
      return Boolean(group && groupTriggered(group));
    });
    if (hasActiveHero) {
      if (heroRows.length === 1) fillSingleRow(heroRows[0]);
      else fillRows(heroRows);
    } else if (accessoryRows.length === 1) fillSingleRow(accessoryRows[0]);
    else fillRows(accessoryRows);

    // Only after every eligible family accessory has been considered do we
    // enter the general reserve. Its order is accessories first, cross-hero
    // products second; existing-cart and duplicate suppression still apply.
    if (visible.length < MAX_VISIBLE_OFFERS) fillSingleRow(resolvedRow(FALLBACK_GROUP_ID));

    return {
      offers: visible,
      rows: usedRows,
      groups: usedRows.map(function (row) { return row.group; })
    };
  }

  function safeProductHandle(state, productId) {
    var entry = state.prices && state.prices.products && state.prices.products[String(productId)];
    var handle = String(entry && entry.handle || "");
    return /^[a-z0-9][a-z0-9-]*$/.test(handle) ? handle : "";
  }

  function safeImageUrl(value) {
    if (!value) return "";
    try {
      var parsed = new URL(String(value), window.location.origin);
      if (parsed.protocol !== "https:") return "";
      if (parsed.origin !== window.location.origin && parsed.hostname !== "cdn.shopify.com") return "";
      return parsed.href;
    } catch (error) {
      return "";
    }
  }

  function loadProduct(state, offer) {
    var cacheKey = String(offer.productId);
    if (state.products[cacheKey]) return Promise.resolve(state.products[cacheKey]);
    var handle = safeProductHandle(state, offer.productId);
    if (!handle) return Promise.resolve(null);
    return fetchJson("/products/" + handle + ".js").then(function (product) {
      var variants = (product.variants || []).filter(function (variant) {
        var priceEntry = state.prices.prices && state.prices.prices[String(variant.id)];
        return variant.available !== false && (!priceEntry || priceEntry.available !== false);
      });
      if (!variants.length) throw new Error("No available variants");
      product.variants = variants;
      state.products[cacheKey] = product;
      return product;
    }).catch(function () {
      /* Product publication is authoritative. Never render a stale fallback
         card for a deleted, unpublished, or temporarily unreadable product. */
      return null;
    });
  }

  function variantPrice(state, variant) {
    var verified = state.prices.prices && state.prices.prices[String(variant.id)];
    return Number(verified && verified.cents !== undefined ? verified.cents : variant.price || 0);
  }

  function variantTitle(variant) {
    var title = String(variant.title || "");
    if (!title || title === "Default Title") title = "Standard";
    return title;
  }

  function variantLabel(state, variant) {
    return variantTitle(variant) + " — " + money(variantPrice(state, variant));
  }

  function matchedVariantMarkup(state, variant) {
    return "<span class=\"tk9-icu-native__matched\">" + escapeHtml(variantLabel(state, variant)) + "</span>";
  }

  function singleVariantPriceMarkup(state, variant) {
    return "<span class=\"tk9-icu-native__price\">" + escapeHtml(money(variantPrice(state, variant))) + "</span>";
  }

  function upgradeDeltaCents(state, offer, variant) {
    var source = offer.upgradePlan && offer.upgradePlan.sourceLine || {};
    var sourcePrice = Number(source.original_price || source.price || source.final_price || 0);
    return Number(variantPrice(state, variant)) - sourcePrice;
  }

  function upgradePriceMarkup(state, offer, variant) {
    var delta = upgradeDeltaCents(state, offer, variant);
    if (delta > 0) {
      return "<span class=\"tk9-icu-native__price tk9-icu-native__price--upgrade\"><strong>+" +
        escapeHtml(shortMoney(delta)) + "</strong></span>";
    }
    if (delta < 0) {
      return "<span class=\"tk9-icu-native__price tk9-icu-native__price--upgrade\"><strong>" +
        escapeHtml("-" + shortMoney(delta)) + "</strong></span>";
    }
    return "<span class=\"tk9-icu-native__price tk9-icu-native__price--upgrade\"><strong>Included</strong></span>";
  }

  function upgradeButtonLabel(state, offer, variant) {
    var delta = upgradeDeltaCents(state, offer, variant);
    if (delta > 0) return "Upgrade +" + shortMoney(delta);
    if (delta < 0) return "Upgrade -" + shortMoney(delta);
    return "Upgrade";
  }

  function compactOfferTitle(value) {
    return String(value || "")
      .replace(/^Team K9(?:®|™)?\s*/i, "")
      .replace(/Tactical Bungee Dog Leash/i, "Tactical Bungee Leash")
      .replace(/12-Patch Harness Bundle/i, "12-Patch Bundle");
  }

  function selectedVariant(product, preferredId) {
    return (product.variants || []).find(function (variant) {
      return Number(variant.id) === Number(preferredId);
    }) || (product.variants || [])[0] || null;
  }

  function contextMatchedVariantId(offer) {
    var size = String(offer.size || "");
    var color = String(offer.color || "");
    var sizeValue = size && offer.sizeVariantMap && offer.sizeVariantMap[size];
    if (sizeValue && typeof sizeValue === "object" && color && sizeValue[color]) {
      return Number(sizeValue[color]);
    }
    if (sizeValue && typeof sizeValue !== "object") return Number(sizeValue);
    if (color && offer.variantMap && offer.variantMap[color]) return Number(offer.variantMap[color]);
    return 0;
  }

  function propertyFields(offer) {
    return (offer.requiresProperties || []).map(function (field) {
      var name = String(field.name || field.label || "Text");
      var isPhone = /phone/i.test(name);
      return "<label class=\"tk9-icu-native__field\">" +
        "<span>" + escapeHtml(field.label || name) + (field.required ? " *" : "") + "</span>" +
        "<input class=\"tk9-icu-native__input\" type=\"" + (isPhone ? "tel" : "text") + "\" " +
          "data-tk9-icu-native-property=\"" + escapeHtml(name) + "\" " +
          "data-required=\"" + (field.required ? "1" : "0") + "\" " +
          "maxlength=\"" + escapeHtml(field.maxLength || 40) + "\" " +
          "placeholder=\"" + escapeHtml(field.placeholder || "") + "\" " +
          "autocomplete=\"" + escapeHtml(field.autocomplete || "off") + "\" " +
          "autocapitalize=\"" + escapeHtml(field.autocapitalize || "characters") + "\" spellcheck=\"false\">" +
      "</label>";
    }).join("");
  }

  function offerMarkup(state, offer, product) {
    var variants = product.variants || [];
    if ((offer.variantChoices || []).length) {
      var allowedVariants = Object.create(null);
      offer.variantChoices.forEach(function (choice) { allowedVariants[String(choice.variantId)] = true; });
      variants = variants.filter(function (variant) { return allowedVariants[String(variant.id)]; });
    }
    var isUpgrade = offer.action === "change_variant" && offer.upgradePlan;
    var isHarnessVersionUpgrade = isUpgrade && offer.id === "upgrade-2mbh-to-4mbh";
    var selected = selectedVariant({ variants: variants }, offer.variantId);
    // /products/{handle}.js can expose only the first 250 variants. The
    // verified price map still contains every exact mapped target, so keep a
    // later target exact instead of silently rendering the product's first
    // variant for MultiCam/Olive and other deep catalog combinations.
    if (isUpgrade && (!selected || Number(selected.id) !== Number(offer.variantId))) {
      var verifiedTarget = state.prices.prices && state.prices.prices[String(offer.variantId)];
      if (!verifiedTarget || verifiedTarget.available === false) return "";
      selected = {
        id: Number(offer.variantId),
        title: offer.title || "4-Buckle Harness",
        price: Number(verifiedTarget.cents || 0),
        available: true
      };
      variants = [selected];
    }
    if (!selected) return "";
    offer.selectedVariantId = Number(selected.id);
    var image = safeImageUrl(
      (isUpgrade ? offer.image : selected.featured_image && selected.featured_image.src) ||
      product.featured_image || offer.image ||
      state.prices.products[String(offer.productId)] && state.prices.products[String(offer.productId)].image
    );
    if (!image) return "";
    var fullDisplayTitle = isUpgrade || (offer.variantChoices || []).length
      ? offer.title
      : product.title || offer.title;
    var displayTitle = compactOfferTitle(offer.title || fullDisplayTitle);
    var needsCustomization = (offer.requiresProperties || []).length > 0;
    var automaticMatch = Number(selected.id) === contextMatchedVariantId(offer);
    var selector = isHarnessVersionUpgrade
      ? upgradePriceMarkup(state, offer, selected)
      : variants.length === 1 || isUpgrade
        ? singleVariantPriceMarkup(state, selected)
      : "<select class=\"tk9-icu-native__select\" data-tk9-icu-native-select data-tk9-icu-native-auto-matched=\"" + (automaticMatch ? "1" : "0") + "\" aria-label=\"Choose " + escapeHtml(product.title || offer.title) + " option\">" +
          variants.map(function (variant) {
            return "<option value=\"" + escapeHtml(variant.id) + "\"" +
              (Number(variant.id) === Number(selected.id) ? " selected" : "") + ">" +
              escapeHtml(variantLabel(state, variant)) + "</option>";
          }).join("") +
          "</select>";
    var buttonLabel = isHarnessVersionUpgrade
      ? upgradeButtonLabel(state, offer, selected)
      : isUpgrade ? offer.buttonLabel || "Upgrade" : needsCustomization ? "Customize" : "Add";
    return "<article class=\"tk9-icu-native__offer" + (needsCustomization ? " tk9-icu-native__offer--personalizable" : "") + "\" role=\"listitem\" data-tk9-icu-native-offer=\"" + escapeHtml(offerKey(offer)) + "\">" +
      "<div class=\"tk9-icu-native__media\">" +
        (image ? "<img src=\"" + escapeHtml(image) + "\" alt=\"\" width=\"240\" height=\"240\" loading=\"lazy\" decoding=\"async\" data-tk9-icu-native-image>" : "") +
      "</div>" +
      "<div class=\"tk9-icu-native__body\">" +
        "<h3 class=\"tk9-icu-native__title\" title=\"" + escapeHtml(fullDisplayTitle) + "\">" + escapeHtml(displayTitle) + "</h3>" +
        "<div class=\"tk9-icu-native__variant\">" + selector + "</div>" +
        (needsCustomization ? "<div class=\"tk9-icu-native__properties\" data-tk9-icu-native-properties hidden>" + propertyFields(offer) + "</div>" : "") +
        "<button class=\"tk9-icu-native__add\" type=\"button\" data-tk9-icu-native-add" +
          (needsCustomization ? " data-tk9-icu-native-customize aria-expanded=\"false\"" : "") + ">" +
          escapeHtml(buttonLabel) +
        "</button>" +
        "<p class=\"tk9-icu-native__error\" data-tk9-icu-native-error role=\"alert\" hidden></p>" +
      "</div>" +
    "</article>";
  }

  function panelTitle() {
    return "Picked for your cart";
  }

  function relocateBeforeCartTitle(root) {
    var title = document.querySelector(".cart-page__title");
    if (!title || !title.parentNode) return false;
    if (root.parentNode !== title.parentNode || root.nextElementSibling !== title) {
      title.insertAdjacentElement("beforebegin", root);
    }
    return root.isConnected;
  }

  function refreshRecommendations(root, state) {
    if (state.refreshing) {
      state.refreshQueued = true;
      return;
    }
    state.refreshing = true;
    fetchJson(state.config.cartUrl).then(function (cart) {
      state.cart = cart;
      if (!state.cart.item_count || wasDismissed(state)) {
        root.hidden = true;
        return;
      }
      /* Do not erase shopper-entered patch text during an unrelated cart
         mutation. Rebuild as soon as the customizer closes instead. */
      if (state.customizer) {
        state.refreshPending = true;
        return;
      }
      state.refreshPending = false;
      state.visible = buildVisibleOffers(state.core, state.rules, state.prices, state.cart);
      if (!state.visible.offers.length) {
        root.hidden = true;
        return;
      }
      return render(root, state);
    }).then(function () {
      state.refreshing = false;
      if (state.refreshQueued) {
        state.refreshQueued = false;
        refreshRecommendations(root, state);
      }
    }, function () {
      /* A refresh failure leaves the last verified module in place. The cart
         and checkout remain authoritative and fully usable. */
      state.refreshing = false;
      if (state.refreshQueued) {
        state.refreshQueued = false;
        refreshRecommendations(root, state);
      }
    });
  }

  function scheduleRecommendationRefresh(root, state, delay) {
    if (state.refreshTimer) window.clearTimeout(state.refreshTimer);
    state.refreshTimer = window.setTimeout(function () {
      state.refreshTimer = null;
      refreshRecommendations(root, state);
    }, Number(delay || 0));
  }

  function keepMountedAcrossCartRefreshes(root, state) {
    if (state.mountObserver || !window.MutationObserver || !document.body) return;
    state.mountObserver = new MutationObserver(function () {
      if (root.isConnected || state.mountQueued) return;
      state.mountQueued = true;
      var reattach = function () {
        state.mountQueued = false;
        relocateBeforeCartTitle(root);
      };
      if (window.requestAnimationFrame) window.requestAnimationFrame(reattach);
      else window.setTimeout(reattach, 0);
    });
    state.mountObserver.observe(document.body, { childList: true, subtree: true });

    /* Horizon emits cart:update before it morphs quantity/remove sections.
       Legacy Team K9 cart helpers use the other two event names. Discount
       updates intentionally only need the observer: eligibility is unchanged,
       and keeping the same node preserves any patch text already entered. */
    ["cart:update", "cart:updated", "cart:refresh"].forEach(function (name) {
      document.addEventListener(name, function () {
        scheduleRecommendationRefresh(root, state, 650);
      });
    });
  }

  function updateOfferCount(root, count, hasOpenCustomizer, hiddenCount, expanded) {
    var offerCount = root.querySelector("[data-tk9-icu-native-offer-count]");
    if (!offerCount) return;
    offerCount.hidden = false;
    offerCount.textContent = "";
    if (!hasOpenCustomizer) {
      offerCount.textContent = String(count) + " option" + (count === 1 ? "" : "s");
      return;
    }
    offerCount.appendChild(document.createTextNode(String(count) + " shown"));
    if (!hiddenCount) return;
    offerCount.appendChild(document.createTextNode(" · "));
    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.setAttribute("data-tk9-icu-native-customizer-more", "");
    toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
    toggle.textContent = expanded ? "Show fewer" : "Show " + String(hiddenCount) + " more";
    offerCount.appendChild(toggle);
  }

  function dismissalKey(state) {
    var token = String(state.cart && state.cart.token || "cart").replace(/[^a-zA-Z0-9_-]/g, "").slice(0, 80);
    return "tk9_icu_native_dismissed_" + token;
  }

  function wasDismissed(state) {
    try { return window.sessionStorage.getItem(dismissalKey(state)) === "1"; }
    catch (error) { return false; }
  }

  function dismiss(root, state) {
    try { window.sessionStorage.setItem(dismissalKey(state), "1"); }
    catch (error) { /* dismissal still applies to this view */ }
    root.hidden = true;
    emit(state, "tk9_upsell_dismiss", { tk9_offer_groups: state.visible.groups.map(function (group) { return group.id; }).join(",") });
  }

  function sanitizeProperty(value) {
    return String(value || "").replace(/[^\x20-\x7E]/g, "").replace(/\s{2,}/g, " ").trim().toUpperCase();
  }

  function collectProperties(card, offer) {
    var properties = {};
    var error = "";
    var fields = offer.requiresProperties || [];
    fields.forEach(function (field) {
      var name = String(field.name || field.label || "Text");
      var input = Array.prototype.find.call(card.querySelectorAll("[data-tk9-icu-native-property]"), function (node) {
        return node.getAttribute("data-tk9-icu-native-property") === name;
      });
      var value = sanitizeProperty(input && input.value);
      if (field.required && !value && !error) error = (field.label || name) + " is required.";
      if (value) properties[name] = value;
    });
    return { properties: properties, error: error };
  }

  function attributionProperties(state, offer) {
    var properties = {
      "_tk9_source": "native_icu_cart_page",
      "_tk9_offer_id": String(offer.id || ""),
      "_tk9_offer_group": String(offer.groupId || ""),
      "_tk9_cart_surface": state.config.surface
    };
    if (offer.color || offer.size) {
      properties._tk9_variant_match = [offer.color, offer.size].filter(Boolean).join(" / ");
    }
    return properties;
  }

  function customPatchProperties(properties, state) {
    var name = properties["Which text or name you want printed"] || "";
    var phone = properties["Which phone number you want printed (optional)"] || "";
    properties._tk9_patch_mockup_format = "svg_v4_pair_cart_single_preview";
    properties._tk9_patch_mockup_line_1 = name;
    properties._tk9_patch_mockup_line_2 = phone;
    properties._tk9_custom_patch_source = "cart";
    properties._tk9_custom_patch_label = "Cart";
    properties._tk9_custom_patch_surface = state.config.surface;
    properties._tk9_custom_patch_source_label = "Cart";
    properties._tk9_custom_patch_source_surface = state.config.surface;
    return properties;
  }

  function submitCartForm(variantId, properties) {
    var form = document.createElement("form");
    form.method = "post";
    form.action = "/cart/add";
    form.hidden = true;
    var fields = Object.assign({ id: String(variantId), quantity: "1" }, Object.keys(properties).reduce(function (output, key) {
      output["properties[" + key + "]"] = String(properties[key]);
      return output;
    }, {}));
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function lineVariantId(line) {
    return Number(line && (line.variant_id || line.id) || 0);
  }

  function findLineByVariant(cart, variantId) {
    return ((cart && cart.items) || []).find(function (line) {
      return lineVariantId(line) === Number(variantId);
    }) || null;
  }

  function restoreTargetQuantity(state, targetVariantId, originalQuantity) {
    return fetchJson(state.config.cartUrl).then(function (cart) {
      var targetLine = findLineByVariant(cart, targetVariantId);
      if (!targetLine) return cart;
      return fetchJson(state.config.changeUrl, {
        method: "POST",
        body: JSON.stringify({ id: targetLine.key, quantity: originalQuantity })
      });
    }).catch(function () {
      /* Best-effort rollback; the visible error tells the shopper to refresh. */
    });
  }

  function upgradeOffer(state, offer, properties) {
    var plan = offer.upgradePlan;
    var existingTarget = findLineByVariant(state.cart, plan.targetVariantId);
    var originalTargetQuantity = Number(existingTarget && existingTarget.quantity || 0);
    return fetchJson(state.config.addUrl, {
      method: "POST",
      body: JSON.stringify({
        items: [{
          id: plan.targetVariantId,
          quantity: plan.targetQuantity,
          properties: properties
        }]
      })
    }).then(function () {
      /* Shopify regenerates line keys after an add, so re-fetch before removing
         the single-kit source. This prevents a stale-key duplicate bundle. */
      return fetchJson(state.config.cartUrl);
    }).then(function (freshCart) {
      var sourceVariantId = lineVariantId(plan.sourceLine);
      var freshSource = findLineByVariant(freshCart, sourceVariantId);
      if (!freshSource) return freshCart;
      return fetchJson(state.config.changeUrl, {
        method: "POST",
        body: JSON.stringify({ id: freshSource.key, quantity: plan.remainder })
      }).catch(function (error) {
        return restoreTargetQuantity(state, plan.targetVariantId, originalTargetQuantity).then(function () {
          throw error;
        });
      });
    });
  }

  function addOffer(root, state, card, offer) {
    if (state.busy) return;
    var button = card.querySelector("[data-tk9-icu-native-add]");
    var errorNode = card.querySelector("[data-tk9-icu-native-error]");
    var selectedId = Number(offer.selectedVariantId || offer.variantId || 0);
    var propertyResult = collectProperties(card, offer);
    if (!selectedId || propertyResult.error) {
      errorNode.textContent = propertyResult.error || "Please choose an available option.";
      errorNode.hidden = false;
      return;
    }
    errorNode.hidden = true;
    var properties = Object.assign(attributionProperties(state, offer), propertyResult.properties);
    if (Number(offer.productId) === PATCH_PRODUCT_ID) customPatchProperties(properties, state);

    state.busy = true;
    button.disabled = true;
    var isUpgrade = offer.action === "change_variant" && offer.upgradePlan;
    var isHarnessVersionUpgrade = isUpgrade && offer.id === "upgrade-2mbh-to-4mbh";
    var selectedVariant = state.products[String(offer.productId)] && (state.products[String(offer.productId)].variants || []).find(function (variant) {
      return Number(variant.id) === selectedId;
    }) || { id: selectedId, price: state.prices.prices && state.prices.prices[String(selectedId)] && state.prices.prices[String(selectedId)].cents || 0 };
    var idleLabel = isHarnessVersionUpgrade
      ? upgradeButtonLabel(state, offer, selectedVariant)
      : isUpgrade ? offer.buttonLabel || "Upgrade" : "Add";
    button.textContent = isUpgrade ? "Upgrading…" : "Adding…";
    emit(state, "tk9_upsell_add", {
      tk9_offer_id: offer.id,
      tk9_offer_group: offer.groupId,
      tk9_product_id: offer.productId,
      tk9_variant_id: selectedId,
      tk9_variant_matched: Boolean(offer.color || offer.size)
    });

    var request = isUpgrade
      ? upgradeOffer(state, offer, properties)
      : fetchJson(state.config.addUrl, {
        method: "POST",
        body: JSON.stringify({ items: [{ id: selectedId, quantity: 1, properties: properties }] })
      });

    request.then(function () {
      button.textContent = isUpgrade ? "Upgraded ✓" : "Added ✓";
      var status = root.querySelector("[data-tk9-icu-native-status]");
      if (status) status.textContent = (isUpgrade ? "Upgraded to " : "Added ") + (offer.title || "recommended product") + (isUpgrade ? "." : " to cart.");
      window.setTimeout(function () { window.location.reload(); }, 180);
    }).catch(function (error) {
      if (!isUpgrade && Number(error && error.status) === 429) {
        emit(state, "tk9_upsell_add_form_fallback", {
          tk9_offer_id: offer.id,
          tk9_variant_id: selectedId
        });
        submitCartForm(selectedId, properties);
        return;
      }
      state.busy = false;
      button.disabled = false;
      button.textContent = idleLabel;
      errorNode.textContent = isUpgrade
        ? "That upgrade was not completed. Your original item remains in the cart. Please refresh and try again."
        : "That item was not added. Please try again.";
      errorNode.hidden = false;
      emit(state, "tk9_upsell_add_error", {
        tk9_offer_id: offer.id,
        tk9_variant_id: selectedId,
        tk9_status: Number(error && error.status || 0)
      });
    });
  }

  function updateVariant(state, card, offer, variantId) {
    var product = state.products[String(offer.productId)];
    var variant = product && (product.variants || []).find(function (item) {
      return Number(item.id) === Number(variantId);
    });
    if (!variant) return;
    offer.selectedVariantId = Number(variant.id);
    var image = safeImageUrl(variant.featured_image && variant.featured_image.src);
    var node = card.querySelector("[data-tk9-icu-native-image]");
    if (node && image) {
      node.src = image;
      node.removeAttribute("srcset");
    }
  }

  function openCustomizer(root, state, card, offer) {
    var customizer = root.querySelector("[data-tk9-icu-native-customizer]");
    var host = root.querySelector("[data-tk9-icu-native-customizer-card]");
    var properties = card.querySelector("[data-tk9-icu-native-properties]");
    var add = card.querySelector("[data-tk9-icu-native-add]");
    if (!customizer || !host || !properties || !add) return;
    var parent = card.parentNode;
    state.customizer = {
      card: card,
      next: card.nextElementSibling,
      parent: parent,
      totalOfferCount: parent ? parent.querySelectorAll("[data-tk9-icu-native-offer]").length : 1,
      suppressed: [],
      expanded: false
    };
    card.classList.add("is-customizing");
    card.setAttribute("role", "group");
    properties.hidden = false;
    add.setAttribute("aria-expanded", "true");
    add.textContent = "Add";
    host.appendChild(card);
    if (parent) {
      var companions = Array.prototype.slice.call(parent.querySelectorAll("[data-tk9-icu-native-offer]"));
      root.setAttribute("data-tk9-icu-native-customizer-companion-count", String(companions.length));
      state.customizer.suppressed = companions.slice(3);
      state.customizer.suppressed.forEach(function (node) {
        node.hidden = true;
        node.setAttribute("data-tk9-icu-native-customizer-suppressed", "1");
      });
      updateOfferCount(root, Math.min(3, companions.length), true, state.customizer.suppressed.length, false);
    }
    customizer.hidden = false;
    root.setAttribute("data-tk9-icu-native-customizer-open", "1");
    var firstField = properties.querySelector("[data-tk9-icu-native-property]");
    if (firstField) firstField.focus();
    emit(state, "tk9_upsell_customize_open", { tk9_offer_id: offer.id, tk9_product_id: offer.productId });
  }

  function toggleCustomizerCompanions(root, state) {
    var saved = state.customizer;
    if (!saved || !(saved.suppressed || []).length) return;
    saved.expanded = !saved.expanded;
    root.setAttribute("data-tk9-icu-native-customizer-expanded", saved.expanded ? "1" : "0");
    (saved.suppressed || []).forEach(function (node) {
      node.hidden = !saved.expanded;
    });
    var baseCount = Math.max(0, saved.totalOfferCount - 1 - saved.suppressed.length);
    var shownCount = baseCount + (saved.expanded ? saved.suppressed.length : 0);
    updateOfferCount(root, shownCount, true, saved.suppressed.length, saved.expanded);
    emit(state, "tk9_upsell_customize_companions_toggle", {
      tk9_expanded: saved.expanded,
      tk9_hidden_offer_count: saved.suppressed.length
    });
  }

  function closeCustomizer(root, state) {
    var customizer = root.querySelector("[data-tk9-icu-native-customizer]");
    var saved = state.customizer;
    if (!customizer || !saved || !saved.card || !saved.parent) return;
    var card = saved.card;
    var properties = card.querySelector("[data-tk9-icu-native-properties]");
    var add = card.querySelector("[data-tk9-icu-native-add]");
    card.classList.remove("is-customizing");
    card.setAttribute("role", "listitem");
    if (properties) properties.hidden = true;
    if (add) {
      add.setAttribute("aria-expanded", "false");
      add.textContent = "Customize";
    }
    (saved.suppressed || []).forEach(function (node) {
      node.hidden = false;
      node.removeAttribute("data-tk9-icu-native-customizer-suppressed");
    });
    if (saved.next && saved.next.parentNode === saved.parent) saved.parent.insertBefore(card, saved.next);
    else saved.parent.appendChild(card);
    customizer.hidden = true;
    root.removeAttribute("data-tk9-icu-native-customizer-open");
    root.removeAttribute("data-tk9-icu-native-customizer-expanded");
    root.removeAttribute("data-tk9-icu-native-customizer-companion-count");
    updateOfferCount(root, saved.parent.querySelectorAll("[data-tk9-icu-native-offer]").length, false);
    state.customizer = null;
    if (add) add.focus();
    emit(state, "tk9_upsell_customize_close", {});
    if (state.refreshPending) scheduleRecommendationRefresh(root, state, 0);
  }

  function bind(root, state) {
    root.addEventListener("click", function (event) {
      var toggleCustomizer = event.target.closest("[data-tk9-icu-native-customizer-more]");
      if (toggleCustomizer) {
        event.preventDefault();
        toggleCustomizerCompanions(root, state);
        return;
      }
      var cancelCustomizer = event.target.closest("[data-tk9-icu-native-customizer-cancel]");
      if (cancelCustomizer) {
        event.preventDefault();
        closeCustomizer(root, state);
        return;
      }
      var close = event.target.closest("[data-tk9-icu-native-close]");
      if (close) {
        event.preventDefault();
        dismiss(root, state);
        return;
      }
      var add = event.target.closest("[data-tk9-icu-native-add]");
      if (!add) return;
      var card = add.closest("[data-tk9-icu-native-offer]");
      var offer = card && state.offerByKey[card.getAttribute("data-tk9-icu-native-offer")];
      if (!card || !offer) return;
      if (add.hasAttribute("data-tk9-icu-native-customize") && !card.classList.contains("is-customizing")) {
        openCustomizer(root, state, card, offer);
        return;
      }
      addOffer(root, state, card, offer);
    });

    root.addEventListener("change", function (event) {
      var select = event.target.closest("[data-tk9-icu-native-select]");
      if (!select) return;
      var card = select.closest("[data-tk9-icu-native-offer]");
      var offer = card && state.offerByKey[card.getAttribute("data-tk9-icu-native-offer")];
      if (card && offer) updateVariant(state, card, offer, Number(select.value));
    });
  }

  function render(root, state) {
    var heading = root.querySelector("[data-tk9-icu-native-heading]");
    var list = root.querySelector("[data-tk9-icu-native-offers]");
    var offerCount = root.querySelector("[data-tk9-icu-native-offer-count]");
    if (!heading || !list || !state.visible.offers.length) return;
    heading.textContent = panelTitle();
    state.offerByKey = Object.create(null);

    return Promise.all(state.visible.offers.map(function (offer) {
      return loadProduct(state, offer).then(function (product) {
        if (!product) return "";
        state.offerByKey[offerKey(offer)] = offer;
        return offerMarkup(state, offer, product);
      });
    })).then(function (rows) {
      list.innerHTML = rows.filter(Boolean).join("");
      if (!list.children.length) return;
      Array.prototype.forEach.call(list.querySelectorAll("[data-tk9-icu-native-image]"), function (image) {
        var removeBrokenCard = function () {
          var card = image.closest("[data-tk9-icu-native-offer]");
          if (card) card.remove();
          if (!list.children.length) root.hidden = true;
        };
        image.addEventListener("error", removeBrokenCard, { once: true });
        /* A newly inserted loading="lazy" image can report complete=true and
           naturalWidth=0 before it enters the browser's load queue. The error
           event is authoritative; the eager synchronous check could otherwise
           delete valid successor cards on a shopper's first uncached visit. */
      });
      if (!list.children.length) return;
      var hasComplexOffer = state.visible.offers.some(function (offer) {
        return offer.action === "change_variant" || (offer.requiresProperties || []).length > 0;
      });
      root.classList.toggle("tk9-icu-native--complex", hasComplexOffer);
      root.setAttribute("data-tk9-icu-native-offer-count", String(list.children.length));
      if (offerCount) updateOfferCount(root, list.children.length, false);
      relocateBeforeCartTitle(root);
      root.hidden = false;
      emit(state, "tk9_upsell_impression", {
        tk9_offer_groups: state.visible.groups.map(function (group) { return group.id; }).join(","),
        tk9_offer_ids: state.visible.offers.map(function (offer) { return offer.id; }).join(","),
        tk9_offer_count: state.visible.offers.length
      });
      state.visible.offers.forEach(function (offer) {
        if (offer.color || offer.size) {
          emit(state, "tk9_upsell_variant_match", {
            tk9_offer_id: offer.id,
            tk9_product_id: offer.productId,
            tk9_variant_id: offer.variantId,
            tk9_match_color: offer.color || "",
            tk9_match_size: offer.size || ""
          });
        }
      });
    });
  }

  function init(root) {
    var core = window.TK9NativeCartCore;
    if (!core || typeof core.buildRecommendations !== "function") return;
    var state = {
      core: core,
      config: hardenConfig(parseJsonScript(root, "[data-tk9-icu-native-config]")),
      cart: null,
      rules: null,
      prices: null,
      visible: null,
      products: Object.create(null),
      offerByKey: Object.create(null),
      customizer: null,
      busy: false,
      refreshing: false,
      refreshQueued: false,
      refreshPending: false,
      refreshTimer: null,
      mountObserver: null,
      mountQueued: false
    };
    bind(root, state);
    Promise.all([
      fetchJson(state.config.cartUrl),
      fetchJson(state.config.rulesUrl),
      fetchJson(state.config.pricesUrl)
    ]).then(function (values) {
      state.cart = values[0];
      state.rules = values[1];
      state.prices = values[2];
      core.assertValidRules(state.rules);
      if (!state.cart.item_count || wasDismissed(state)) return;
      state.visible = buildVisibleOffers(core, state.rules, state.prices, state.cart);
      if (!state.visible.offers.length) return;
      keepMountedAcrossCartRefreshes(root, state);
      return render(root, state);
    }).catch(function () {
      root.hidden = true;
      /* Recommendations fail closed. Theme cart and checkout stay untouched. */
    });
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
})();
